import { cpfMask } from '@/app/utils/cpfFormater'
import { Button } from '@/view/components/ui/button'
import { User, Calendar, IdCard, Phone, MapPin } from 'lucide-react'
import { Input } from './Input'
import { phoneMask } from '@/app/utils/phoneFormater'
import { useFormContext } from 'react-hook-form'
import { AllSchemas } from '../schema'
import { zipCodeMask } from '@/app/utils/zipCodeFormater'
import { CreditCard } from '@/view/components/CreditCard'
import { dateMask } from '@/app/utils/dateFormater'

const CreditBalanceForm = ({
  onNext,
  hasCrefaz = false,
}: {
  onNext: () => void
  hasCrefaz?: boolean
}) => {
  const methods = useFormContext<AllSchemas>()

  return (
    <CreditCard>
      <h2 className="sm:text-2xl text-center mb-1 font-bold text-black01 text-xl">
        Simule seu empréstimo
      </h2>
      <p className="text-black06 mb-2 sm:mb-0 text-center text-xs font-medium sm:text-base">
        Insira seus dados para simular e resgatar<br />
        o valor disponivel do seu empréstimo
      </p>

      <div
        className="flex flex-col gap-3 sm:pt-5 w-full"
      >

        <Input
          name="name"
          label="Nome completo"
          icon={<User className="mr-1 h-4 w-4 text-black03 sm:h-5 sm:w-5" />}
          error={methods.formState.errors.name?.message}
          placeholder="Insira seu nome"
        />

        <Input
          icon={
            <IdCard className="mr-1 w-4" />
          }
          label="CPF"
          name="cpf"
          error={methods.formState.errors.cpf?.message}
          placeholder="Insira seu cpf"
          onInput={cpfMask}
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 ">

          <Input
            icon={
              <Calendar className="mr-1 h-4 w-4 text-black03" />
            }
            label="Data de nascimento"
            name="birthDate"
            error={methods.formState.errors.birthDate?.message}
            type="text"
            inputMode="numeric"
            maxLength={10}
            onInput={dateMask}
            placeholder="dd/mm/aaaa"
          />

          <Input
            label="Telefone"
            name="phone"
            icon={
              <Phone className="mr-1 h-4 w-4 "/>
            }
            placeholder="Insira seu telefone"
            error={methods.formState.errors.phone?.message}
            onInput={phoneMask}
          />
        </div>

        {hasCrefaz && (
        <Input
          icon={
            <MapPin className="mr-1 h-5 w-5 sm:h-4 sm:w-4" />
          }
          label="CEP"
          name="zipCode"
          error={methods.formState.errors.zipCode?.message}
          placeholder="Insira seu CEP"
          onInput={zipCodeMask}
        />
        )}
        <Button
          type="button"
          onClick={methods.handleSubmit(onNext)}
          className="rounded-xl bg-primary text-base font-bold text-white01 transition-all hover:bg-primary hover:brightness-110 self-center mt-2 w-full"
        >
          Avançar
        </Button>
      </div>
    </CreditCard>
  )
}

export default CreditBalanceForm;
